import {Model} from 'backbone';

class Breadcrumb extends Model.extend({
  url: '/api/breadcrumb'
}) {}

export default Breadcrumb;